export const StyleComponent = {
  searchCapsule: {
    borderRadius: "20px 0 0 20px",
  },
};
